import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import "@/App.css";
import { Toaster } from "sonner";
import { CartProvider } from "@/context/CartContext";
import { CustomerAuthProvider } from "@/context/CustomerAuthContext";
import Home from "@/pages/Home";
import ReviewsPage from "@/pages/Reviews";
import UsedGoodsPage from "@/pages/UsedGoods";
import MerchPage from "@/pages/MerchPage";
import TermsPage from "@/pages/Terms";
import PayPage from "@/pages/PayPage";
import AccountPage from "@/pages/Account";
import AuthCallback from "@/pages/AuthCallback";
import ReceiptPage from "@/pages/ReceiptPage";
import FurnitureDepotPage from "@/pages/FurnitureDepot";
import StorePortalPage from "@/pages/StorePortal";
import CookieBanner from "@/components/site/CookieBanner";
import Analytics from "@/components/site/Analytics";
import { PaymentSuccess, PaymentCancel } from "@/pages/PaymentPages";
import AdminLogin from "@/admin/AdminLogin";
import AdminShell from "@/admin/AdminShell";
import Dashboard from "@/admin/Dashboard";
import MerchAdmin from "@/admin/MerchAdmin";
import MarketplaceAdmin from "@/admin/MarketplaceAdmin";
import PricingAdmin from "@/admin/PricingAdmin";
import BeforeAfterAdmin from "@/admin/BeforeAfterAdmin";
import TodayAdmin from "@/admin/TodayAdmin";
import ReviewsAdmin from "@/admin/ReviewsAdmin";
import HeroImagesAdmin from "@/admin/HeroImagesAdmin";
import OpsList from "@/admin/OpsList";
import ClaimsAdmin from "@/admin/ClaimsAdmin";
import FurnitureDepotAdmin from "@/admin/FurnitureDepotAdmin";

function AppRouter() {
  const location = useLocation();
  // Google sign-in lands at {origin}/account#session_id=... — exchange it before any route renders.
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/reviews" element={<ReviewsPage />} />
      <Route path="/used-goods" element={<UsedGoodsPage />} />
      <Route path="/merch" element={<MerchPage />} />
      <Route path="/terms" element={<TermsPage />} />
      <Route path="/furnituredepot" element={<FurnitureDepotPage />} />
      <Route path="/furniture-depot" element={<Navigate to="/furnituredepot" replace />} />
      <Route path="/store/:token" element={<StorePortalPage />} />
      <Route path="/account" element={<AccountPage />} />
      <Route path="/pay/:ref" element={<PayPage />} />
      <Route path="/receipt/:ref" element={<ReceiptPage />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin" element={<AdminShell />}>
        <Route index element={<Navigate to="/admin/dashboard" replace />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="hero-images" element={<HeroImagesAdmin />} />
        <Route path="merch" element={<MerchAdmin />} />
        <Route path="marketplace" element={<MarketplaceAdmin />} />
        <Route path="reviews" element={<ReviewsAdmin />} />
        <Route path="pricing" element={<PricingAdmin />} />
        <Route path="before-after" element={<BeforeAfterAdmin />} />
        <Route path="today" element={<TodayAdmin />} />
        <Route path="bookings" element={<OpsList kind="bookings" />} />
        <Route path="inquiries" element={<OpsList kind="inquiries" />} />
        <Route path="orders" element={<OpsList kind="orders" />} />
        <Route path="claims" element={<ClaimsAdmin />} />
        <Route path="furniture-depot" element={<FurnitureDepotAdmin />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <CartProvider>
        <CustomerAuthProvider>
          <BrowserRouter>
            <AppRouter />
            <Analytics />
            <CookieBanner />
          </BrowserRouter>
        </CustomerAuthProvider>
        <Toaster position="top-right" richColors closeButton />
      </CartProvider>
    </div>
  );
}

export default App;
